<!--  -->
<template>
  <div class="listshchoolInfo">
    <div class="badgeUrl">
      <img :src="shchoolInfo.badgeUrl" />
    </div>
    <div class="schoolInfo">
      <div class="schoolTitle">{{ shchoolInfo.name }}</div>
      <div class="schoolAddress">地址：{{ shchoolInfo.areaName }}</div>
      <div class="schoolType">
        <div v-if="shchoolInfo.flag985">985</div>
        <div v-if="shchoolInfo.flag211" style=" color: #6191f2;background: #f5f9ff">211</div>
        <div v-if="shchoolInfo.proSchoolTypeName" style=" color: #5fb59e;background: #f4fff6">
          {{ shchoolInfo.proSchoolTypeName }}
        </div>
        <div v-if="shchoolInfo.isDoubleFirst" style=" color: #8b7ce3;background: #f8f6ff">
          双一流
        </div>
        <div v-if="shchoolInfo.isSelfScribing" style=" color: #fcb51a;background: #fff7db">
          自划线
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    shchoolInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.listshchoolInfo {
  display: flex;
  align-items: center;
  width: 678px;
  // margin: 22px auto;
  // margin-top: 24px;
  padding: 25px 0 25px 25px;
  background-color: #fff;
  border-radius: 14px;

  .badgeUrl {
    width: 134px;
    height: 134px;
    padding: 26px;
    background: #fff;
    // border: 2px solid #dedede;
    border-radius: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .schoolInfo {
    margin-left: 30px;

    .schoolTitle {
      color: #1f1f39;
      font-weight: bold;
      font-size: 29px;
      line-height: 48px;
    }

    .schoolAddress {
      margin: 15px 0;
      color: #666;
      font-size: 22px;
      line-height: 32px;
    }

    .schoolType {
      display: flex;
      flex-wrap: wrap;
      div:first-child {
        margin-left: 0;
      }

      div {
        margin: 7px;
        padding: 2px 10px;
        color: var(--themeColor);
        font-size: 22px;
        line-height: 40px;
        text-align: center;
        background: #fef5f1;
        border-radius: 10px;
      }
    }
  }
}
</style>
